import React from "react";

function ConfirmDialog({ message, onConfirm, onCancel }) {
  return (
    <div className="dialog-backdrop">
      <div className="dialog-box">
        <p className="dialog-message">{message}</p>
        <div className="dialog-actions">
          <button className="dialog-btn cancel" onClick={onCancel}>
            Cancel
          </button>
          <button className="dialog-btn delete" onClick={onConfirm}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;
